<template>
  <b-form-row>
    <validating-group
      :label="$t('inputs.customer.street')"
      :validation-context="validationContext"
      :validation-path="`${validationPath}.street`"
      :rules="validationRules"
      v-slot="{ clearErrors, state }"
      class="col-12"
    >
      <b-form-input
        v-e2e:customerStreet
        v-model="model.street"
        @input="
          modelChanged();
          clearErrors();
        "
        :readonly="readonly"
        :state="state"
      />
    </validating-group>
    <validating-group
      :label="$t('inputs.customer.post-code')"
      :validation-context="validationContext"
      :validation-path="`${validationPath}.postal_code`"
      :rules="validationRules"
      v-slot="{ clearErrors, state }"
      class="col"
    >
      <b-form-input
        v-e2e:customerPostCode
        v-model="model.postal_code"
        @input="
          modelChanged();
          clearErrors();
        "
        :readonly="readonly"
        :state="state"
      />
    </validating-group>
    <b-form-group :label="$t('inputs.customer.city')" class="col">
      <b-form-input
        v-e2e:customerCity
        v-model="model.city"
        @input="modelChanged"
        :readonly="readonly"
      />
    </b-form-group>
    <validating-group
      :label="$t('inputs.customer.country')"
      :validation-context="validationContext"
      :validation-path="`${validationPath}.country_code`"
      :rules="validationRules"
      v-slot="{ clearErrors, state }"
      class="col"
    >
      <b-form-select
        v-e2e:customerCountry
        v-model="model.country_code"
        @input="
          modelChanged();
          clearErrors();
        "
        :options="countries"
        :disabled="readonly"
        :state="state"
      />
    </validating-group>
  </b-form-row>
</template>

<script>
import BaseInput from './mixins/BaseInput';
import ValidatingInput from '../mixins/ValidatingInput';
import { CountryCodeEnum } from '@gid/models';

export default {
  mixins: [BaseInput, ValidatingInput],
  props: {
    inputName: {
      type: String,
    },
  },
  data() {
    return {
      model: {
        city: null,
        country: null,
        country_code: null,
        postal_code: null,
        street: null,
      },
      countries: Object.keys(CountryCodeEnum).map((el) => {
        return {
          value: CountryCodeEnum[el],
          text: this.$t(`country.${el.toLowerCase()}`),
        };
      }),
    };
  },
  watch: {
    passedValue() {
      this.loadModel();
    },
  },
  created() {
    this.loadModel();
  },
  methods: {
    loadModel() {
      if (this.passedValue) {
        this.model = JSON.parse(JSON.stringify(this.passedValue));
      }
    },
    modelChanged() {
      this.commitOrEmit(JSON.parse(JSON.stringify(this.model)));
    },
    countryChanged(newCountryCode) {
      const countryDef = this.countries.find(
        ({ value }) => value == newCountryCode,
      );
      this.model.country = countryDef ? countryDef.text : null;
      this.modelChanged();
    },
  },
};
</script>
